import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { RacingService } from '../../services/racing-service';

@Component({
    selector: 'ms-fixture-market-title',
    templateUrl: 'fixture-market-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FixtureMarketTitleComponent implements OnChanges {
    @Input() fixture: WinGameFixture;
    @Input() isHorseRace = false;
    title = '';
    distance = '';

    constructor(private racingService: RacingService) {}

    ngOnChanges(changes: ISimpleChanges<FixtureMarketTitleComponent>): void {
        if (changes.fixture && changes.fixture.currentValue) {
            const fixture = changes.fixture.currentValue;
            this.title = this.racingService.getMarketName(fixture);
            this.distance = fixture.addons.distance;
        } else {
            this.title = '';
            this.distance = '';
        }
    }
}
